import { useOrganizationProposalChecklistItemsQuery } from "generated/graphql";
import { useCallback, useMemo } from "react";

export default function useGetOrganizationProposalChecklistItems() {
  const {
    data: graphqlData,
    loading,
    error,
    refetch,
  } = useOrganizationProposalChecklistItemsQuery({
    fetchPolicy: "cache-first",
  });

  const getData = useCallback((data) => {
    return data?.organizationProposalChecklistItems || [];
  }, []);

  const data = useMemo(() => {
    return getData(graphqlData);
  }, [graphqlData, getData]);

  return { loading, data, error, refetch } as const;
}
